import React from 'react';
export function Footer() {
  return <footer className="py-8 text-center border-t border-neutral-900 bg-neutral-950" data-id="element-47">
      <p className="text-neutral-600 text-sm" data-id="element-48">
        © {new Date().getFullYear()} The Vape-to-Zero Blueprint. All rights
        reserved.
      </p>
    </footer>;
}